(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[66390,14777,25591,44725,93509,22432,52892,49954,94596,44243,93375,22456,95660],{

/***/ 39625:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moveyouout/terms-and-conditions",
      function () {
        return __webpack_require__(77292);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
const { useSyncExternalStore  } =  true ? __webpack_require__(67294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 77292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ InsureYourCarHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_shared_legal_termsAndConditions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10761);
/* harmony import */ var _components_layouts_moveyououtWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16255);



var __N_SSP = true;
function InsureYourCarHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_moveyououtWrapper__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_legal_termsAndConditions__WEBPACK_IMPORTED_MODULE_1__["default"], {
            category: "Moving",
            domain: "MoveYouOut.com"
        })
    });
}


/***/ }),

/***/ 97943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Facebook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#4780c0",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1514",
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.121 10H43.208V25H26.121z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1514)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M33.155 24.318h3.04v-6.881h2.12l.232-2.301h-2.353v-1.31c0-.548.116-.756.7-.756h1.653v-2.388h-2.115c-2.268 0-3.289.898-3.289 2.618v1.841h-1.586v2.329h1.586l.012 6.848z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Facebook);


/***/ }),

/***/ 22371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Twitter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#35a9ff",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.025 10H43.111999999999995V25H26.025z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32_1513)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M26.01 22.15a10.97 10.97 0 005.135 1.374 11.06 11.06 0 005.201-1.167c1.58-.8 2.878-1.965 3.755-3.369.877-1.403 1.298-2.99 1.217-4.59a6.803 6.803 0 001.779-1.595 7.52 7.52 0 01-2.012.484c.736-.38 1.289-.984 1.553-1.697a7.756 7.756 0 01-2.22.75 3.665 3.665 0 00-1.983-.933c-.76-.111-1.54.002-2.22.32-.68.32-1.22.826-1.537 1.442a2.725 2.725 0 00-.218 1.966 11.02 11.02 0 01-3.997-.927 9.796 9.796 0 01-3.218-2.277 2.746 2.746 0 00-.38 2.234c.203.76.727 1.424 1.467 1.856a3.872 3.872 0 01-1.553-.381c-.01.715.265 1.41.777 1.966s1.228.939 2.026 1.081a4.064 4.064 0 01-1.553.055 3.1 3.1 0 001.24 1.525 3.804 3.804 0 002.022.602 7.394 7.394 0 01-2.492 1.114 7.931 7.931 0 01-2.79.168z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_1513",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17.048V12.164H0z",
                        transform: "translate(26.025 11.364)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Twitter);


/***/ }),

/***/ 43808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pinterest() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#e60023",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1516",
                style: {
                    maskType: "alpha"
                },
                width: "19",
                height: "15",
                x: "25",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M25.93 10H43.016999999999996V25H25.93z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1516)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M30.756 18.573a.327.327 0 00.382-.078.262.262 0 00.056-.117c.037-.14.129-.486.172-.631.043-.145.037-.263-.123-.436a2.15 2.15 0 01-.573-1.541c-.007-.505.1-1.005.314-1.47.214-.466.53-.887.929-1.239a4.177 4.177 0 011.392-.806 4.492 4.492 0 011.631-.244c2.33 0 3.607 1.29 3.607 3.01 0 2.262-1.104 4.172-2.75 4.172a1.46 1.46 0 01-.613-.103 1.331 1.331 0 01-.494-.343 1.168 1.168 0 01-.27-.509 1.1 1.1 0 01.014-.564c.26-.994.765-2.066.765-2.792.02-.15.005-.3-.045-.444a1.03 1.03 0 00-.244-.388 1.162 1.162 0 00-.4-.26 1.265 1.265 0 00-.483-.087c-.924 0-1.67.866-1.67 2.028-.006.428.088.853.277 1.245l-1.116 4.273a8.05 8.05 0 000 2.982c.004.02.014.038.03.053a.12.12 0 00.055.03.13.13 0 00.064 0 .12.12 0 00.055-.032 8.308 8.308 0 001.566-2.57c.104-.351.616-2.161.616-2.161.233.312.549.566.918.738.37.171.782.256 1.197.245 2.787 0 4.673-2.301 4.673-5.384 0-2.324-2.176-4.468-5.48-4.468-4.12 0-6.166 2.675-6.166 4.903-.056 1.34.505 2.542 1.714 2.988z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pinterest);


/***/ }),

/***/ 8281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/oneElement/index.tsx
var oneElement = __webpack_require__(36895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/styles.module.scss
var styles_module = __webpack_require__(48378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/Share.tsx



const Share = ({ shareList  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shareList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: `cursor-pointer  ${(styles_module_default())[el.name]}`,
                onClick: ()=>{
                    window.open(el.link, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                    return false;
                },
                children: el.icon
            }, index))
    });
};
/* harmony default export */ var share_Share = (Share);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Facebook.tsx
var Facebook = __webpack_require__(97943);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Twitter.tsx
var Twitter = __webpack_require__(22371);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/pinterest.tsx
var pinterest = __webpack_require__(43808);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx









function Mobile() {
    const { asPath  } = (0,router.useRouter)();
    const { blogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const shareList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
            link: `https://www.facebook.com/sharer/sharer.php?u=https://${domain.name}${asPath}`,
            name: "facebook"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {}),
            link: `https://twitter.com/share?url=https://${domain.name}${asPath}`,
            name: "twitter"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pinterest/* default */.Z, {}),
            link: `http://pinterest.com/pin/create/button/?url=https://${domain.name}${asPath}`,
            name: "pinterest"
        }, 
    ];
    const myList = [
        {
            title: "Contents",
            slug: "contents",
            content: (0,sharedUtils/* getMainTitlesNavigationFromBody */._H)(blogPost?.model.body)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `   px-5 py-10  max-h-[80vh] flex flex-col justify-between `,
        children: [
            myList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(oneElement/* default */.Z, {
                    content: el.content
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `mt-4 text-sm font-bold`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `flex  gap-2 mt-3 justify-center  `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Share, {
                            shareList: shareList
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OneElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25086);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);



function OneElement({ content  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (content?.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linksList)}      `,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg mt-8 mb-5 hidden lg:block ",
                    children: "Contents"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto",
                    children: content?.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `
                                ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bulletedListItem)} pl-5    
                                     pb-5  `,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: el?.link ?? "#",
                                dangerouslySetInnerHTML: {
                                    __html: el?.title
                                },
                                onClick: ()=>setModal({
                                        active: false,
                                        content: undefined
                                    }),
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linkColor)}   block  cursor-pointer text-sm `
                            })
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 48378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__EYfOu","twitter":"styles_twitter__47r59","pintrest":"styles_pintrest__w6OTr"};

/***/ }),

/***/ 25086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__aZ9m3","linksList":"style_linksList__xLuOw","bulletedListItem":"style_bulletedListItem__H1JoX"};

/***/ }),

/***/ 14777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","legal":"legal_legal__qUt4s","ccpaMainContainer":"legal_ccpaMainContainer__EgCgv","decimalStyleOnlyLi":"legal_decimalStyleOnlyLi__qBRw_","decimalStyle":"legal_decimalStyle__ostDo","alphaStyle":"legal_alphaStyle__B5bJA","timeStyle":"legal_timeStyle__bx7dw"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,10761,16255,49774,92888,40179], function() { return __webpack_exec__(39625); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);